/* ==========================================================================
   NASHIRA HERITAGE - RUNTIME
   ========================================================================== */
document.documentElement.classList.add('ns-js');

(function () {
  'use strict';

  var NS = (window.NSHeritage = window.NSHeritage || {});

  /* ------------------------------------------------------------------
     MONEY
     ------------------------------------------------------------------ */
  NS.formatMoney = function (cents) {
    var format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || null;
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var value = whole + '.' + parts[1];
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    }
    return 'Rs. ' + value;
  };

  /* ------------------------------------------------------------------
     REVEAL ON SCROLL
     ------------------------------------------------------------------ */
  NS.initReveal = function (root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.ns-reveal:not([data-ns-observed])');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('ns-in');
      });
      return;
    }

    if (!NS._io) {
      NS._io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('ns-in');
              NS._io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
      );
    }

    items.forEach(function (el, i) {
      el.setAttribute('data-ns-observed', '');
      var group = el.closest('[data-ns-stagger]');
      var delay = group ? (i % 4) * 70 : 0;
      el.style.transitionDelay = delay + 'ms';
      NS._io.observe(el);
    });
  };

  /* ------------------------------------------------------------------
     CART - ajax add
     ------------------------------------------------------------------ */
  NS.addToCart = function (variantId, quantity) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add_failed');
      return r.json();
    });
  };

  NS.refreshCart = function () {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      try {
        drawer.show();
      } catch (e) {}
    }
  };

  NS.toast = function (msg) {
    var el = document.createElement('div');
    el.className = 'ns-toast';
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.add('ns-toast--in');
    });
    setTimeout(function () {
      el.classList.remove('ns-toast--in');
      setTimeout(function () {
        el.remove();
      }, 400);
    }, 2600);
  };

  /* Quick add buttons across all ns product grids */
  NS.initQuickAdd = function (root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ns-quick-add]:not([data-ns-bound])').forEach(function (btn) {
      btn.setAttribute('data-ns-bound', '');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var url = btn.getAttribute('data-ns-url');
        if (btn.getAttribute('data-ns-quick-add') === 'options') {
          if (url) window.location.href = url;
          return;
        }

        var id = btn.getAttribute('data-ns-variant');
        if (!id) return;

        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        NS.addToCart(id, 1)
          .then(function () {
            btn.textContent = 'Added';
            NS.refreshCart();
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 1400);
          })
          .catch(function () {
            btn.textContent = 'Unavailable';
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 1600);
          });
      });
    });
  };

  /* ------------------------------------------------------------------
     LIFT THE OVERLAYS OUT OF THE HEADER SECTION

     The menu drawer, the search drawer and the scrim are authored inside
     sections/ns-header.liquid, but that section wrapper is sticky and
     z-indexed, which makes it a stacking context. Left inside it the drawers
     are pinned to the header's layer no matter how high their own z-index is,
     and every body-level overlay in the theme paints straight over an open
     drawer: the cart drawer (999), the PDP sticky add-to-cart bar (9990) and
     the collection filter sheets (9995). Moving them onto <body> is what lets
     the --ns-z-* scale in ns-heritage.css actually apply.

     appendChild moves the node, so listeners bound to it survive the lift.
     ------------------------------------------------------------------ */
  NS.liftOverlays = function () {
    ['[data-ns-scrim]', '[data-ns-drawer]', '[data-ns-search-drawer]'].forEach(function (sel) {
      var nodes = Array.prototype.slice.call(document.querySelectorAll(sel));
      var fresh = nodes.filter(function (n) { return n.parentNode !== document.body; });
      /* Nothing new inside a section: already lifted, leave it alone. */
      if (!fresh.length) return;
      /* A section re-render in the theme editor rebuilds the node inside the
         header, so drop the copy lifted last time before lifting this one. */
      nodes.forEach(function (n) {
        if (n.parentNode === document.body) n.parentNode.removeChild(n);
      });
      document.body.appendChild(fresh[fresh.length - 1]);
    });
  };

  /* ------------------------------------------------------------------
     GOKWIK CHECKOUT IS ON SCREEN

     GoKwik mounts #gokwik-modal-wrapper on <body> and the only event its SDK
     emits is `modal_closed`, so there is nothing to listen to for "opened".
     Watching the DOM is the one signal that works for every entry point - the
     PDP Buy Now button, the cart drawer and the cart page alike.

     .ns-gokwik-open is what the header and the sticky bars key off to get out
     of the way; this function is its only owner.
     ------------------------------------------------------------------ */
  NS.watchGokwik = function () {
    if (NS._gkWatching || !window.MutationObserver) return;
    NS._gkWatching = true;

    var queued = false;
    var watched = null;
    var closeBound = false;

    function visible(el) {
      if (!el) return false;
      /* offsetParent is useless here - the wrapper is position:fixed. */
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    function sync() {
      queued = false;
      var wrapper = document.querySelector('#gokwik-modal-wrapper, #gokwik-iframe');

      /* GoKwik sometimes hides the wrapper instead of unmounting it, and an
         inline style change is an attribute mutation the childList observer
         below never sees - so watch the wrapper itself once it turns up. */
      if (wrapper && wrapper !== watched) {
        watched = wrapper;
        attrs.observe(wrapper, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      }

      /* The SDK always emits modal_closed on close: belt to the observer's braces. */
      if (!closeBound && window.gokwikSdk && typeof window.gokwikSdk.on === 'function') {
        closeBound = true;
        window.gokwikSdk.on('modal_closed', schedule);
      }

      document.body.classList.toggle('ns-gokwik-open', visible(wrapper));
    }

    function schedule() {
      if (queued) return;
      queued = true;
      /* setTimeout, not requestAnimationFrame: rAF is throttled to nothing on a
         backgrounded tab, and the class has to be right when the shopper
         comes back to it. */
      setTimeout(sync, 0);
    }

    var attrs = new MutationObserver(schedule);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    sync();
  };

  /* ------------------------------------------------------------------
     MOBILE DRAWER
     ------------------------------------------------------------------ */
  NS.initDrawer = function () {
    var drawer = document.querySelector('[data-ns-drawer]');
    var scrim = document.querySelector('[data-ns-scrim]');
    if (!drawer) return;

    function toggle(open) {
      drawer.classList.toggle('ns-open', open);
      if (scrim) scrim.classList.toggle('ns-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    document.querySelectorAll('[data-ns-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        toggle(true);
      });
    });
    document.querySelectorAll('[data-ns-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () {
        toggle(false);
      });
    });
    if (scrim) {
      scrim.addEventListener('click', function () {
        toggle(false);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') toggle(false);
    });

    /* Accordion submenus inside drawer */
    drawer.querySelectorAll('[data-ns-sub-toggle]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var parent = t.closest('.ns-dr__item');
        if (parent) parent.classList.toggle('ns-open');
      });
    });
  };

  /* ------------------------------------------------------------------
     HEADER SHADOW ON SCROLL
     ------------------------------------------------------------------ */
  NS.initHeader = function () {
    var header = document.querySelector('[data-ns-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('ns-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  /* ------------------------------------------------------------------
     PRODUCT PAGE
     ------------------------------------------------------------------ */
  NS.initProduct = function () {
    var root = document.querySelector('[data-ns-product]');
    if (!root) return;

    var data = null;
    var script = root.querySelector('[data-ns-product-json]');
    if (script) {
      try {
        data = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
    }
    if (!data) return;

    var form = root.querySelector('.ns-form-product') || root.querySelector('[data-ns-product-form]');
    var idInput = root.querySelector('[data-ns-variant-id]');
    var priceEl = root.querySelector('[data-ns-price]');
    var compareEl = root.querySelector('[data-ns-compare]');
    var saveEl = root.querySelector('[data-ns-save]');
    var atc = root.querySelector('[data-ns-atc]');
    /* The PDP Buy Now button, which now opens GoKwik. [data-ns-buy-now] was
       the wrapper around Shopify's dynamic checkout button; kept only so an
       older section that still emits it does not lose its sold-out state. */
    var buyNow = root.querySelector('[data-ns-buynow]') || root.querySelector('[data-ns-buy-now]');

    function setBuyNowAvailable(ok) {
      if (!buyNow) return;
      if (buyNow.tagName === 'BUTTON') {
        buyNow.disabled = !ok;
      } else {
        buyNow.style.display = ok ? '' : 'none';
      }
    }
    var skuEl = root.querySelector('[data-ns-sku]');
    var stockEl = root.querySelector('[data-ns-stock]');
    var stickyPrice = document.querySelector('[data-ns-sticky-price]');
    var stickyAtc = document.querySelector('[data-ns-sticky-atc]');
    var inventoryBar = root.querySelector('[data-ns-inv-bar]');
    var inventoryText = root.querySelector('[data-ns-inv-text]');

    var options = Array.prototype.slice.call(root.querySelectorAll('[data-ns-option-index]'));

    function currentSelections() {
      var sel = [];
      options.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-ns-option-index'), 10);
        var checked = group.querySelector('input:checked');
        if (checked) sel[idx] = checked.value;
      });
      return sel;
    }

    function findVariant(sel) {
      return (
        data.variants.filter(function (v) {
          return v.options.every(function (o, i) {
            return sel[i] === undefined || o === sel[i];
          });
        })[0] || null
      );
    }

    function setAvailability(sel) {
      /* Disable option values that produce no purchasable combination */
      options.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-ns-option-index'), 10);
        group.querySelectorAll('input').forEach(function (input) {
          var test = sel.slice();
          test[idx] = input.value;
          var match = data.variants.filter(function (v) {
            return v.options.every(function (o, i) {
              return test[i] === undefined || o === test[i];
            });
          });
          var any = match.some(function (v) {
            return v.available;
          });
          var label = input.closest('label') || group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('ns-unavailable', !any);
        });
      });
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var target = root.querySelector('[data-ns-media-id="' + variant.featured_media.id + '"]');
      if (!target) return;
      var stage = root.querySelector('[data-ns-gallery-stage]');
      if (!stage) return;
      stage.querySelectorAll('[data-ns-media-id]').forEach(function (s) {
        s.classList.remove('ns-active');
      });
      target.classList.add('ns-active');
      root.querySelectorAll('[data-ns-thumb]').forEach(function (t) {
        t.classList.toggle('ns-active', t.getAttribute('data-ns-thumb') === String(variant.featured_media.id));
      });
    }

    function update() {
      var sel = currentSelections();
      setAvailability(sel);
      var variant = findVariant(sel);

      /* Reflect selected value label */
      options.forEach(function (group) {
        var out = group.querySelector('[data-ns-option-value]');
        var checked = group.querySelector('input:checked');
        if (out && checked) out.textContent = checked.value;
      });

      if (!variant) {
        if (atc) {
          atc.disabled = true;
          atc.textContent = 'Unavailable';
        }
        setBuyNowAvailable(false);
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) priceEl.textContent = NS.formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = NS.formatMoney(variant.price);

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = NS.formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (saveEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          saveEl.textContent = 'Save ' + pct + '%';
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }

      if (skuEl) skuEl.textContent = variant.sku || '';

      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? atc.getAttribute('data-ns-label') || 'Add To Cart' : 'Sold Out';
      }
      if (stickyAtc) {
        stickyAtc.disabled = !variant.available;
        stickyAtc.textContent = variant.available ? 'Add To Cart' : 'Sold Out';
      }
      setBuyNowAvailable(variant.available);

      if (stockEl) {
        stockEl.textContent = variant.available ? 'In Stock' : 'Out of Stock';
        stockEl.classList.toggle('ns-out', !variant.available);
      }

      if (inventoryBar && inventoryText) {
        var qty = variant.inventory_quantity;
        var mgmt = variant.inventory_management;
        if (mgmt && variant.available && typeof qty === 'number' && qty > 0) {
          var max = parseInt(inventoryBar.getAttribute('data-ns-max') || '30', 10);
          var pctv = Math.max(6, Math.min(100, (qty / max) * 100));
          inventoryBar.style.setProperty('--ns-inv', pctv + '%');
          inventoryBar.parentElement.style.display = '';
          inventoryText.textContent = qty <= 10 ? 'Only ' + qty + ' left, selling fast' : qty + ' in stock';
        } else if (inventoryBar.parentElement) {
          inventoryBar.parentElement.style.display = 'none';
        }
      }

      updateMedia(variant);

      /* Update URL */
      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      root.dispatchEvent(new CustomEvent('ns:variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    options.forEach(function (group) {
      group.addEventListener('change', update);
    });

    /* QUANTITY */
    var qtyInput = root.querySelector('[data-ns-qty-input]');
    root.querySelectorAll('[data-ns-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var v = parseInt(qtyInput.value, 10) || 1;
        v += btn.getAttribute('data-ns-qty') === 'up' ? 1 : -1;
        qtyInput.value = Math.max(1, v);
      });
    });

    /* ADD TO CART */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!atc || atc.disabled) return;
        var id = idInput ? idInput.value : null;
        var q = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (!id) return;

        var label = atc.textContent;
        atc.disabled = true;
        atc.textContent = 'Adding...';

        NS.addToCart(id, q)
          .then(function () {
            atc.textContent = 'Added To Cart';
            NS.refreshCart();
            setTimeout(function () {
              atc.textContent = label;
              atc.disabled = false;
            }, 1600);
          })
          .catch(function () {
            atc.textContent = 'Could Not Add';
            setTimeout(function () {
              atc.textContent = label;
              atc.disabled = false;
            }, 1800);
          });
      });
    }

    if (stickyAtc && form) {
      stickyAtc.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    /* GALLERY (legacy fade stage) */
    /* The section now ships a scroll-snap carousel owned by ns-pdp.js. This
       block targets the old [data-ns-gallery-stage] markup, so it no-ops on
       the stage but would still fight the carousel over thumb active state. */
    var stage = root.querySelector('[data-ns-gallery-stage]');
    if (stage) {
      root.querySelectorAll('[data-ns-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.getAttribute('data-ns-thumb');
          stage.querySelectorAll('[data-ns-media-id]').forEach(function (s) {
            s.classList.toggle('ns-active', s.getAttribute('data-ns-media-id') === id);
          });
          root.querySelectorAll('[data-ns-thumb]').forEach(function (t) {
            t.classList.toggle('ns-active', t === thumb);
          });
        });
      });
    }

    /* GALLERY ZOOM (desktop hover pan) */
    root.querySelectorAll('[data-ns-zoom]').forEach(function (frame) {
      var img = frame.querySelector('img');
      if (!img) return;
      frame.addEventListener('mousemove', function (e) {
        var r = frame.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
      frame.addEventListener('mouseenter', function () {
        frame.classList.add('ns-zooming');
      });
      frame.addEventListener('mouseleave', function () {
        frame.classList.remove('ns-zooming');
        img.style.transformOrigin = 'center center';
      });
    });

    /* ACCORDIONS */
    root.querySelectorAll('[data-ns-acc-trigger]').forEach(function (t) {
      t.addEventListener('click', function () {
        var item = t.closest('[data-ns-acc]');
        if (item) item.classList.toggle('ns-open');
      });
    });

    /* STICKY BAR VISIBILITY */
    var bar = document.querySelector('[data-ns-sticky-bar]');
    var anchor = root.querySelector('[data-ns-sticky-anchor]');
    if (bar && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            bar.classList.toggle('ns-show', !en.isIntersecting && en.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      ).observe(anchor);
    }

    update();
  };

  /* ------------------------------------------------------------------
     COUNTDOWN
     ------------------------------------------------------------------ */
  NS.initCountdown = function () {
    document.querySelectorAll('[data-ns-countdown]:not([data-ns-bound])').forEach(function (el) {
      el.setAttribute('data-ns-bound', '');
      var target = new Date(el.getAttribute('data-ns-countdown')).getTime();
      if (isNaN(target)) return;

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          el.classList.add('ns-ended');
          diff = 0;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var out = el.querySelectorAll('[data-ns-cd]');
        var map = { d: d, h: h, m: m, s: s };
        out.forEach(function (o) {
          var k = o.getAttribute('data-ns-cd');
          o.textContent = String(map[k]).padStart(2, '0');
        });
      }
      tick();
      setInterval(tick, 1000);
    });
  };

  /* ------------------------------------------------------------------
     TABS (shared)
     ------------------------------------------------------------------ */
  NS.initTabs = function () {
    document.querySelectorAll('[data-ns-tabs]:not([data-ns-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-ns-bound', '');
      var tabs = wrap.querySelectorAll('[data-ns-tab]');
      var panes = wrap.querySelectorAll('[data-ns-pane]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-ns-tab');
          tabs.forEach(function (t) {
            t.classList.toggle('ns-active', t === tab);
          });
          panes.forEach(function (p) {
            p.classList.toggle('ns-active', p.getAttribute('data-ns-pane') === key);
          });
        });
      });
    });
  };

  /* ------------------------------------------------------------------
     CAROUSEL (drag / arrows)
     ------------------------------------------------------------------ */
  NS.initCarousel = function () {
    document.querySelectorAll('[data-ns-carousel]:not([data-ns-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-ns-bound', '');
      var track = wrap.querySelector('[data-ns-track]');
      if (!track) return;
      var prev = wrap.querySelector('[data-ns-prev]');
      var next = wrap.querySelector('[data-ns-next]');

      function step() {
        var first = track.children[0];
        return first ? first.getBoundingClientRect().width + 28 : 320;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      var down = false, startX = 0, scrollStart = 0;
      track.addEventListener('pointerdown', function (e) {
        down = true;
        startX = e.pageX;
        scrollStart = track.scrollLeft;
        track.classList.add('ns-dragging');
      });
      window.addEventListener('pointerup', function () {
        down = false;
        track.classList.remove('ns-dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        track.scrollLeft = scrollStart - (e.pageX - startX);
      });
    });
  };

  /* ------------------------------------------------------------------
     BOOT
     ------------------------------------------------------------------ */
  function boot() {
    NS.initReveal();
    NS.initQuickAdd();
    NS.liftOverlays();
    NS.watchGokwik();
    NS.initDrawer();
    NS.initHeader();
    NS.initProduct();
    NS.initCountdown();
    NS.initTabs();
    NS.initCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    NS.initReveal(e.target);
    NS.initQuickAdd(e.target);
    NS.liftOverlays();
    NS.watchGokwik();
    NS.initDrawer();
    NS.initHeader();
    NS.initProduct();
    NS.initCountdown();
    NS.initTabs();
    NS.initCarousel();
  });
  document.addEventListener('shopify:section:select', function () {
    document.querySelectorAll('.ns-reveal').forEach(function (el) {
      el.classList.add('ns-in');
    });
  });

  /* ------------------------------------------------------------------
     Cart badge visibility.

     The "is-empty" class is written by Liquid at page render, and it is
     what sets opacity:0 on the badge. Nothing removed it again, so after
     adding to the cart the number updated underneath but stayed invisible
     until a full page reload - the shopper could not see that anything
     had been added.

     Watching the <cart-count> text rather than hooking one add-to-cart
     path means this holds however the count changes: the quick-add on
     cards, the product form, the cart drawer, or a third-party app.
     ------------------------------------------------------------------ */
  function syncCartBadges() {
    document.querySelectorAll('.ns-cart-count').forEach(function (badge) {
      var n = parseInt((badge.textContent || '').replace(/[^0-9]/g, ''), 10);
      badge.classList.toggle('is-empty', !(n > 0));
    });
  }

  function watchCartBadges() {
    var badges = document.querySelectorAll('.ns-cart-count');
    if (!badges.length) return;

    syncCartBadges();

    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(syncCartBadges);
      badges.forEach(function (badge) {
        observer.observe(badge, { childList: true, characterData: true, subtree: true });
      });
    }

    /* Belt and braces: the events the rest of this theme already fires. */
    ['ns:cart:added', 'cart:change', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(syncCartBadges, 60); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartBadges);
  } else {
    watchCartBadges();
  }
})();
